import React from 'react';
import styles from './ImageSizeGuide.module.scss';

const ImageSizeGuide = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>📐 Довідник розмірів для каруселі</h2>
          <button onClick={onClose} className={styles.closeBtn}>×</button>
        </div>
        
        <div className={styles.content}>
          <div className={styles.mainRule}>
            <h3>🎯 Головне правило</h3>
            <p><strong>Можна завантажити окремі картинки для десктопу і мобільного</strong></p>
            <p>Якщо не завантажити окремі картинки, використовується оригінальна картинка контенту</p>
          </div>
          
          <div className={styles.section}>
            <h3> Рекомендовані розміри</h3>
            <div className={styles.sizeCard}>
              <div className={styles.sizeExample}></div>
              <div>
                <h4>🖥️ Десктоп: 1200x600px</h4>
                <p>• Широкий формат для великих екранів</p>
                <p>• Оптимально заповнює карусель</p>
                <h4>📱 Мобільний: 800x800px (квадрат)</h4>
                <p>• Квадратний формат для телефонів</p>
                <p>• Центрування на білому фоні</p>
                <p>• Формат: JPG або WebP</p>
                {/* <p>• Розмір файлу: до 800KB</p> */}
              </div>
            </div>
          </div>

          <div className={styles.guideSections}>
            <div className={styles.section}>
              <h4>🖥️ Десктоп карусель</h4>
              <div className={styles.mockCarousel + ' ' + styles.desktop}>
                <div className={styles.mockImage}>1200×600px</div>
              </div>
              <p>Широкий формат, заповнює всю ширину каруселі</p>
            </div>

            <div className={styles.section}>
              <h4>📱 Мобільна карусель</h4>
              <div className={styles.mockCarousel + ' ' + styles.mobile}>
                <div className={styles.mockImage}>800×800px</div>
              </div>
              <p>Квадратний формат, білий фон, центрування</p>
            </div>
          </div>

          <div className={styles.tips}>
            <h3>💡 Як це працює</h3>
            <ul>
              <li><strong>Пріоритет:</strong> Спочатку шукає окремі картинки каруселі</li>
              <li><strong>Фолбек:</strong> Якщо немає - використовує оригінальну картинку</li>
              <li><strong>Адаптивність:</strong> Автоматично перемикається між версіями</li>
              <li><strong>Оптимізація:</strong> Різні розміри для кращої швидкості</li>
              <li><strong>Формат:</strong> JPG, PNG або WebP</li>
              {/* <li><strong>Розмір файлу:</strong> До 800KB</li> */}
            </ul>
          </div>
        </div>
        
        <div className={styles.footer}>
          <button onClick={onClose} className={styles.okBtn}>
            Зрозуміло
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageSizeGuide;